module.exports = __webpack_public_path__ + "media/images/icons/SVG/059-e0ff278e392690126be46026499e5fbe.svg";